module.exports = __webpack_public_path__ + "img/140.b577b3a8.jpg";